// --------------------------------------------------------------------------
// #TBC - Chart Type Reveal Button
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;
	var $formContent = context.parent().siblings('[data-binding="form-content"]');
	var $chartingSelectorForm = $('[data-binding="charting-selector"]');

	function init() {
		if ($('[data-page="charting-create"]').length > 0) {
			$formContent.show();
		}

		$(context).on('click', function () {
			if ($formContent.is(':visible')) {
				$formContent.slideUp();
			} else {
				$formContent.slideDown();
			}
		});

		$chartingSelectorForm.one('change', 'input[type="radio"]', function () {
			$(this).parents('[data-binding="form-content"]').siblings('.charting-fieldset-legend').find('[data-behavior="charting-type-reveal"]').trigger('click');
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-type-reveal.js
// module id = 243
// module chunks = 0